import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  isShowing = signal<boolean>(false);
  loadingText = signal<string>('Please wait...');

  show(text: string = 'Please wait...') {
    this.loadingText.set(text);
    this.isShowing.set(true);
  }

  hide() {
    this.isShowing.set(false);
  }
  
}
